import React, { } from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Text, ResponsiveContainer } from 'recharts';
import { colors_reports } from '../../constants/colors_reports';


function PaymentsByMonth({ data }) {
  return (
    <div className="mt-2">
      <Text x={300} y={30} fontSize={30} fontWeight="bold" textAnchor="middle">
        Servicios prestados por mes
      </Text>
      <ResponsiveContainer width="95%" height={400} >
        <ComposedChart
          data={data}
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis dataKey="month_year" scale="band" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="ventas" barSize={20} fill={colors_reports[0]} />
          <Line dataKey="servicios" stroke={colors_reports[1]} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}

export default PaymentsByMonth;